/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { v4 as uuidv4 } from 'uuid';
import FormLabel from "./FormLabel";
import { SidebarGlobal } from "./_Sidebar";
import MessageDialog from "./MessageDialog";
import Globals from "../shared/Globals";
import Auth from "../shared/Auth";
import AppActions from "./AppActions";
import Icon from "./Icon";
import { Link } from "react-router-dom";
import { PurchaseOrderGlobal } from "./PurchaseOrders";
import AccountQuickEdit from "./account/AccountQuickEdit";
import Address from "./Address";
import Alert from "./Alert";
import UploadPad from "./UploadPad";
import L from "./Lang";
import Checkout2Modal from "./payment/Checkout2Modal";
import { Pop } from "./PopModal";
import './PurchaseOrderView.css';
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import ProductModal from "./ProductModal";

class PurchaseOrderView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                lineItems: []
            },
            saving: false,
            accountList: [],
            products: [],
            productsLoaded: null,
            totalQuantity: 0,
            totalPrice: 0,
            loading: this.props.params.id ? true : false
        };

        this.loadProducts = this.loadProducts.bind(this);
        this.load = this.load.bind(this);
        this.searchProducts = this.searchProducts.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        this.loadAccountList();
        this.loadShippingMethods();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    loadAccountList(noLoadProducts) {
        qreq.get('/api/account/list', j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list) {
                if (j.list.length === 1)
                    this.state.item.accountID = j.list[0].id;
                this.setState({ accountList: j.list, loaded: true });
                if (!noLoadProducts) {
                    setTimeout(() => {
                        this.loadProducts(this.state.item.accountID);
                    }, 100);
                }
                this.change();
                if (!this.props.params.id) {
                    this.autoSelectAccounts(j.list);
                }
            }
        });
    }

    autoSelectAccounts = async (list) => {
        const item = { ...this.state.item };

        // Billing
        let filtered = list.filter(a => a.passthrough && a.level === 0);
        if (filtered.length === 1) {
            try {
                const j = await qreq.getAsync('/api/account/get/' + filtered[0].id);
                if (j.item) {
                    this.setState({ autoSelectedAccount: j.item });
                    item.accountID = j.item.id;
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }

        // Shipping
        filtered = list.filter(a => a.passthrough && a.canReceiveShipping);
        if (filtered.length === 1) {
            try {
                const j = await qreq.getAsync('/api/account/get/' + filtered[0].id);
                if (j.item) {
                    this.setState({ shipToAccount: j.item });
                    item.shipToAccountID = j.item.id;
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }

        this.setState({ item: item });
    }

    loadShippingMethods = async () => {
        try {
            let j = await qreq.getAsync('/api/shipping-method/list');
            if (j.list) {
                this.setState({ shippingMethods: j.list });
            }
        }
        catch { }
    }

    //load
    loadProducts(accountID, noLoad) {
        qreq.post('/api/product/list?accountID=' + (accountID || '0'), {}, j => {
            if (j.list) {
                var products = [];
                var sizes = [];
                j.list.forEach(i => {
                    var product = products.find(k => k.id === i.name);
                    if (!product) {
                        let p = { id: i.name, name: i.name, obj: i, manufacturerName: i.manufacturerName, isPricePerUnit: i.isPricePerUnit, incrementBy: i.incrementBy, imageIdent: i.imageIdent };
                        products.push(p);
                    }
                    let size = sizes.find(k => k.id === i.name + '-' + i.productSize);
                    if (!size) {
                        sizes.push({ id: i.id, name: i.productSize, productName: i.name, productID: i.id, units: i.units, totalPrice: i.totalPrice, manufacturerName: i.manufacturerName, sellPrice: i.sellPrice });
                    }
                });
                sizes.sort((a, b) => a.name.localeCompare(b.name));
                this.sizes = sizes;
                this.setState({ products: products, productsLoaded: true, _products: j.list });
                if (!noLoad)
                    this.load();

                //~~~
                setTimeout(() => {
                    let li = [...this.state.item.lineItems];
                    li.forEach(i => {
                        let prod = this.state._products.find(x => x.id === i.productID);
                        if (prod) {
                            i.isPricePerUnit = prod.isPricePerUnit;
                            i.imageIdent = prod.imageIdent;
                            i.productID = prod.id;
                            i.incrementBy = prod.incrementBy;
                        }
                    });
                    this.setState({
                        item: { ...this.state.item, lineItems: li }
                    });
                }, 100);
                //~~~
            }
        });
    }



    //update
    updateProducts = (accountID) => {
        if (!accountID)
            return;
        accountID = parseInt(accountID);
        if (!this.state.productsLoaded) {
            setTimeout(() => this.updateProducts(accountID), 100);
            return;
        }
        let products = [...this.state.products];
        qreq.post('/api/product/list?accountID=' + (accountID || '0'), {}, j => {
            if (j.list) {
                let lineItems = [...this.state.item.lineItems];
                j.list.forEach(i => {
                    let product = products.find(a => a.id === i.id);
                    if (product) {
                        product.totalPrice = i.totalPrice;
                        product.sellPrice = i.sellPrice;
                        product.units = i.units;
                        product.isPricePerUnit = i.isPricePerUnit;
                    }

                    let size = this.sizes.find(a => a.id === i.id);
                    if (size) {
                        size.totalPrice = i.totalPrice;
                        size.sellPrice = i.sellPrice;
                        size.units = i.units;
                    }
                    lineItems.forEach(a => {
                        if (a.productID === i.id) {
                            a.totalPrice = i.totalPrice;
                            a.sellPrice = i.sellPrice;
                            a.units = i.units;
                        }
                    });
                });

                products.forEach(zz => {
                    zz.isDisabled = j.list.find(a => a.id === zz.obj.id) ? false : true;
                });

                this.setState({ products: products, item: { ...this.state.item, lineItems }, _products: j.list });
            }
        });

    }

    selectAccount = async (type, id) => {
        if (!id) {
            this.setState({ [type]: null });
            return;
        }
        const item = { ...this.state.item };
        try {
            let j = await qreq.getAsync('/api/account/get/' + id);
            if (j.item) {
                this.setState({ [type]: j.item });
                if (type === 'shipToAccount') {
                    if (j.item.receiverName)
                        item.receiverName = j.item.receiverName;
                    if (j.item.receiverPhone)
                        item.receiverPhone = j.item.receiverPhone;
                }
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.change(null, item);
    }


    loadAccounts = (item) => {
        if (item.accountID)
            this.selectAccount('account', item.accountID);
        if (item.distributorAccountID)
            this.selectAccount('distributorAccount', item.distributorAccountID);
        if (item.subDistributorAccountID)
            this.selectAccount('subDistributorAccount', item.subDistributorAccountID);
        if (item.shipToAccountID)
            this.selectAccount('shipToAccount', item.shipToAccountID);
    }

    accountChange = (v) => {
        this.updateProducts(v);
        this.selectAccount('account', v);
        this.checkIfPaymentEnabled();
    }

    load() {
        if (this.props.params.id) {
            qreq.get('/api/purchase-order/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    j.item.lineItems.forEach(i => {
                        i.sizes = [];
                        i.productSizeID = i.productID;
                        this.filterSizes(i, i.productName);
                    });
                    this.state.item = j.item; //~~~ 
                    this.setState({ item: this.state.item });
                    this.change();
                    this.loadAccounts(j.item);
                    this.loadProducts(j.item.accountID, true);
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }


    submit = async (e, send) => {
        e?.preventDefault();

        let item = { ...this.state.item };

        this.setState({ saving: true });


        item.lineItems.forEach(i => {
            if (!i.isPricePerUnit) return;

            var size = this.sizes.find(j => j.id === Number(i.productSizeID));

            if (!size)
                return;

            i.productID = i.productSizeID;
            i.productSize = size.name;
        });

        if (this.state.shippingAccount) {
            item.shippingAccount = { ...this.state.shippingAccount };
            item.shipToAccountID = 0;
        }

        if (!item.distributorAccountID) item.distributorAccountID = 0;
        if (!item.subDistributorAccountID) item.subDistributorAccountID = 0;
        if (!item.shippingAccountID) item.shippingAccountID = 0;

        if (this.state.modify)
            item.sent = true;


        if (send)
            item.sendAction = true;

        qreq.post('/api/purchase-order/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.props.navigate('/purchase-order');

            this.setState({ saving: false });
        });
    }

    searchProducts(obj) {

    }

    selectProduct(sel) {
        var obj = {
            key: uuidv4(),
            displayName: sel.obj.productName,
            productName: sel.obj.name,
            manufacturerName: sel.obj.manufacturer,
            totalPrice: sel.obj.totalPrice,
            sellPrice: sel.obj.sellPrice,
            units: sel.obj.units,
            isPricePerUnit: sel.obj.isPricePerUnit,
            imageIdent: sel.obj.imageIdent
        };

        // fix for new package products
        if (!sel.obj.isPricePerUnit) {
            let product = this.state._products.find(x => x.id === sel.obj.id);
            if (product) {
                obj.sellPrice = product.sellPrice;
                obj.totalPrice = product.totalPrice;
                obj.productID = sel.obj.id;
                obj.incrementBy = product.incrementBy;
            }
        }

        this.filterSizes(obj, obj.productName);
        this.addToList(this.state.item.lineItems, obj);
        this.setState({ showCatalogModal: false });
        this.change();
    }

    filterSizes(obj, sel) {
        if (!sel || !this.sizes) {
            obj.sizes = [];
            return;
        }
        var sizes = [];
        this.sizes.forEach(i => {
            if (i.productName === sel)
                sizes.push(i);
        });
        obj.sizes = sizes;
    }

    getObjSize(obj, id) {
        return obj.sizes.find(i => i.id === parseInt(id));
    }

    validate(obj) {
        if (obj.qty > obj.incrementBy && obj.qty % obj.incrementBy != 0) {
            obj.qty = obj.qty - (obj.quantity % obj.incrementBy);
        }
        if (obj.qty < obj.incrementBy) {
            obj.qty = obj.incrementBy;
        }
        this.setState({ item: { ...this.state.item } });
        this.change();
    }

    _validate = async (obj, e) => {
        obj.qty = e.target.value;
        if (obj.qty < obj.incrementBy) obj.qty = obj.incrementBy;


        if (Auth.hasRole('consumer') && this.state.item.isInCart) {
            const info = { ...obj, id: obj.productID, quantity: obj.qty };
            try {
                let j = await qreq.postAsync('/api/cart/update', info);
                if (j.errorCode === 0) {
                    Globals.set('cart', j.item);
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }

        this.validate(obj);
    }

    remove = async (obj) => {
        this.state.item.lineItems.splice(this.state.item.lineItems.indexOf(obj), 1);

        if (Auth.hasRole('consumer') && this.state.item.isInCart) {
            const info = { ...obj, id: obj.productID };
            try {
                let j = await qreq.postAsync('/api/cart/remove', info);
                if (j.item) {
                    Globals.set('cart', j.item);
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }

        this.setState({ item: this.state.item });
        this.change();
    }

    change = (e, item) => {
        if (!item) item = { ...this.state.item };
        let totalQuantity = 0, totalPrice = 0;
        this.state.item.lineItems.forEach(i => {
            let qty = parseInt(i.qty);
            totalQuantity += qty;
            totalPrice += qty * parseFloat(i.totalPrice);
        });
        this.setState({ totalQuantity: totalQuantity, totalPrice: totalPrice, item: item, touched: true });
    }

    _changeNotes = (obj, e) => {
        obj.notes = e.target.value;
        this.change();
    }

    changeSize = (obj) => {
        let size = this.getObjSize(obj, obj.productSizeID);
        if (!size) {
            obj.totalPrice = 0;
            obj.sellPrice = 0;
            obj.units = 0;
            this.change();
            return;
        }
        obj.totalPrice = size.totalPrice;
        obj.sellPrice = size.sellPrice;
        obj.units = size.units;
        this.change();
    }

    getSizeForView = (obj) => {
        if (!obj.isPricePerUnit) return 'Standard';
        let size = this.getObjSize(obj, obj.productSizeID);
        return size ? size.name : '';
    }

    _changeSize = (obj, e) => {
        obj.productSizeID = e.target.value;
        this.changeSize(obj);
    }

    getUnitCount = (obj) => {
        return parseInt(obj.qty || 0) * obj.units;
    }

    getAllUnitCount = () => {
        let total = 0;
        this.state.item.lineItems.forEach(i => {
            total += this.getUnitCount(i);
        });
        if (total === 0)
            return '';
        return total;
    }

    modify = () => {
        this.setState({ modify: true, item: { ...this.state.item, sent: false } });
    }

    isCustomCarrier = () => {
        let find = this.state.shippingMethods?.find(i => i.id === parseInt(this.state.item.shippingMethodID));
        if (find && find.carrier === 'CUSTOM')
            return true;
        return false;
    }

    checkIfPaymentEnabled = async () => {
        let account = await this.getAccountAsync(this.state.item.accountID);
        this.setState({ paymentEnabled: account?.isPaymentPortal });
    }

    sendConfirm = async () => {
        Pop.showConfirm(<L>Are you sure you want to send this purchase order?</L>, <L>Submit Order</L>, () => {
            this.submit(null, true);
        });
    }

    pay = (item, e, callback) => {
        this.setState({ showCheckout: true, checkoutCallback: callback, checkoutItem: item });
    }

    getAccountAsync = async (id) => {
        try {
            let j = await qreq.getAsync('/api/account/get/' + id);
            if (j.item)
                return j.item;
        }
        catch (e) {
            console.error(e);
        }
        return null;
    }

    sendPONow = async (item) => {
        item.sending = true;
        try {
            let j = await qreq.postAsync('/api/purchase-order/send', item);
            if (j.errorCode === 0) {
                item.sent = true;
                this.setState({ list: this.state.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        item.sending = false;
    }

    canSend = () => {
        return (!Auth.hasPolicy('billing-distributor') || this.state.item.accountID) && this.state.item.shipToAccountID && !this.state.paymentEnabled;
    }

    catalog = () => {
        this.setState({ showCatalogModal: true, moreInfoProduct: null, moreInfoProductZ: null });
    }

    continueShopping = () => {
        this.props.navigate('/shop');
    }

    moreInfo = async (product) => {
        this.setState({ moreInfoProduct: product });
        try {
            let j = await qreq.getAsync('/api/product/get/' + product.obj.id);
            if (j.item) {
                this.setState({ moreInfoProductZ: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    setCurrentProduct = (a) => {
        const product = this.state._products.find(x => x.id === a.productID);
        if (product)
            this.setState({ currentProduct: product });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Edit Product</L></h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<>
            {(Auth.hasRole('manager')) && <button type="button" className="btn btn-primary" onClick={() => document.getElementById('c-submit').click()}>
                <FontAwesomeIcon icon={fa.faSave} /> <span className="d-none d-md-inline"><L>Save</L></span>
            </button>}
            {this.state.item.sent && Auth.hasRole('manager') && <button type="button" className="btn btn-secondary" onClick={this.modify}>
                <FontAwesomeIcon icon={fa.faPencil} /> <span className="d-none d-md-inline"><L>Modify</L></span>
            </button>}
        </>);

        return <div className="container-fluid">

            {this.state.showCatalogModal && <Modal show={this.state.showCatalogModal} onHide={() => this.setState({ showCatalogModal: false })} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title><L>Product Catalog</L></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.moreInfoProduct ? <div>
                        <button type="button" className="btn btn-secondary btn-lg mb-3" onClick={() => this.setState({ moreInfoProduct: null })}>
                            <Icon icon="faArrowLeft" /> <L>Go Back</L></button>
                        <div className="text-center">
                            <h4><strong>{this.state.moreInfoProduct.obj.productName}</strong></h4>
                            <h5>{this.state.moreInfoProduct.obj.manufacturer}</h5>
                            <div className="row">
                                <div className="col-md-6">
                                    <pre className="mb-3 text-start" style={{ maxWidth: '100%', whiteSpace: 'pre-wrap', wordBreak: 'break-word', overflowWrap: 'break-word', fontFamily: 'Arial' }}>{this.state.moreInfoProduct.obj.specs}</pre>
                                </div>
                                <div className="col-md-6">
                                    <pre className="mb-3 text-start" style={{ maxWidth: '100%', whiteSpace: 'pre-wrap', wordBreak: 'break-word', overflowWrap: 'break-word', fontFamily: 'Arial' }}>{this.state.moreInfoProduct.obj.description}</pre>
                                </div>
                            </div>
                            {this.state.moreInfoProductZ?.images.map((i, idx) => <div key={idx}>
                                <img src={Globals.getStorageURL(i.imageIdent)} className="img-fluid" alt="" />
                            </div>)}
                        </div>
                    </div> : this.state.products.length === 0 ? <Alert><L>No products available for your account. Please contact the administrators.</L></Alert>
                        : <div className="row PurchaseOrdersView-product-wrapper">{this.state.products.map(i => <div key={i.name} className="col-md-4 PurchaseOrdersView-product">
                            <div className="p-3 text-center">
                                <div className="my-2" style={{ height: '150px' }}>
                                    {i.obj.imageIdent ? <img src={Globals.getStorageURL(i.obj.imageIdent)} alt="" className="img-fluid" /> :
                                        <img src={i.obj && i.obj.productName ? '/img/products/' + i.obj.productName.toLowerCase() + '.png' : ''} alt="" className="img-thumb img-fluid" style={{ height: '100px' }} />}
                                </div>
                                <h4>{i.obj.productName}</h4>
                                <div>{i.obj.manufacturer}</div>
                                <div className="d-grid gap-2 mt-2">
                                    <button type="button" className="btn btn-primary btn-lg" onClick={() => this.selectProduct(i)}>Select this Product</button>
                                    {(i.obj.specs || i.obj.description) && <button type="button" className="btn btn-secondary btn-lg" onClick={() => this.moreInfo(i)}>More Information</button>}
                                </div>
                            </div>
                        </div>)}
                        </div>}
                </Modal.Body>
            </Modal>}

            <Checkout2Modal
                show={this.state.showCheckout}
                onHide={() => this.setState({ showCheckout: false })}
                currentItem={this.state.checkoutItem}
                onSuccess={this.state.checkoutCallback}
            />


            <form onSubmit={this.submit}>
                <h1>Purchase Order {this.state.item.sent && PurchaseOrderGlobal.getStatus(this.state.item)}</h1>
                <Breadcrumb path={[['Purchase Order', '/purchase-order/list'], [this.props.params.id ? this.state.item.iid : 'New']]} />

                <AppActions>
                    {((Auth.hasRole('manager') && !this.state.item.completed)) && <button type="submit" className="btn btn-primary btn-lg">
                        <Icon icon="faSave" /> <L>Save</L></button>}
                    {this.canSend() && !this.state.modify && !this.state.item.sent && <button type="button" className="btn btn-success btn-lg" onClick={() => this.sendConfirm()}>
                        <Icon icon="faPaperPlane" /> <L>Submit Order</L></button>}
                </AppActions>

                {Auth.hasRole('master') && this.state.item.confirmed && <div className="alert alert-success">
                    <p><L>This purchase order has been confirmed.</L></p>
                    {false && <Link to={'/purchase-order/' + this.state.item.id + '/checkout'} className="btn btn-primary" onClick={this.checkout}><L>Checkout with Card</L></Link>}
                </div>}

                <div className="row">
                    {Auth.hasRole('distributor') && <div className="col-lg">
                        <Card title="Billing Account">
                            {!this.state.item.id && this.state.accountList.filter(a => a.passthrough && a.level === 0).length === 1 ? <FormLabel model={this.state.accountList[0].name} label="Billing Account" /> :
                                <FormInput model={this.state.item}
                                    name="accountID"
                                    label="Billing *"
                                    labelAsPlaceholder
                                    autoSelect
                                    type="select"
                                    options={this.state.accountList.filter(a => a.passthrough && a.level === 0)}
                                    required
                                    disabled={this.state.item.sent}
                                    onChange={this.accountChange}
                                    onAutoSelect={this.accountChange}
                                />}
                            {!this.state.item.id && this.state.autoSelectedAccount ? <Address item={this.state.autoSelectedAccount.billingAddress} condensed title="Billing Address" />
                                : this.state.account && <Address item={this.state.account.billingAddress} condensed
                                    title="Billing Address" />}
                        </Card>
                    </div>}
                    {Auth.hasRole('distributor') && !(this.state.item.sent && !this.state.item.distributorAccountID) && this.state.accountList?.filter(a => a.passthrough && a.level === 1).length > 0 && <div className="col-lg">
                        <Card title="Distributor Account">
                            {!this.state.item.id && this.state.accountList.length === 1 ? <FormLabel model={this.state.accountList[0].name} label="Distributor Account" /> :
                                <FormInput model={this.state.item}
                                    name="distributorAccountID"
                                    label="Distributor"
                                    labelAsPlaceholder
                                    autoSelect
                                    type="select"
                                    options={this.state.accountList.filter(a => a.passthrough && a.level === 1)}
                                    disabled={this.state.item.sent}
                                    onChange={v => this.selectAccount('distributorAccount', v)}
                                />}
                            {!this.state.item.id && this.state.autoSelectedDistributorAccount ? <Address item={this.state.autoSelectedDistributorAccount.address} condensed
                                title="Contact Address" />
                                : this.state.distributorAccount ? <Address item={this.state.distributorAccount.address} condensed
                                    title="Contact Address" />
                                    : <small><L>Do not select if it does not apply.</L></small>}
                        </Card>
                    </div>}
                </div>
                <div className="row">
                    {Auth.hasRole('sub-distributor') && !(this.state.item.sent && !this.state.item.subDistributorAccountID) && this.state.accountList?.filter(a => a.passthrough && a.level === 2).length > 0 && <div className="col-lg">
                        <Card title="Sub-Distributor Account">
                            {!this.state.item.id && this.state.accountList.length === 1 ? <FormLabel model={this.state.accountList[0].name} label="Distributor Account" /> :
                                <FormInput model={this.state.item}
                                    name="subDistributorAccountID"
                                    label="Sub-Distributor"
                                    labelAsPlaceholder
                                    type="select"
                                    options={this.state.accountList.filter(a => a.passthrough && a.level === 2)}
                                    disabled={this.state.item.sent}
                                    onChange={v => this.selectAccount('subDistributorAccount', v)}
                                />}
                            {this.state.subDistributorAccount ? <Address item={this.state.subDistributorAccount.address} condensed
                                title="Contact Address" />
                                : <small><L>Do not select if it does not apply.</L></small>}
                        </Card>
                    </div>}
                    {Auth.hasRole('distribution-recipient') && <div className="col-lg-12">
                        <Card title="Shipping Account">
                            {!this.state.showAddNewShipping && (
                                !this.state.item.id && this.state.accountList.filter(a => a.passthrough && a.canReceiveShipping).length === 1 ?
                                    <FormLabel model={this.state.accountList[0].name} label="Shipping Account" /> :

                                    <FormInput model={this.state.item}
                                        name="shipToAccountID"
                                        label="Shipping *"
                                        labelAsPlaceholder
                                        type="select"
                                        options={this.state.accountList.filter(a => a.passthrough && a.canReceiveShipping)}
                                        required
                                        disabled={this.state.item.sent}
                                        onChange={v => this.selectAccount('shipToAccount', v)}
                                    />
                            )}
                            {this.state.shipToAccount && <>
                                <div className="row">
                                    <div className="col-md">
                                        <Address item={this.state.shipToAccount.shippingAddress} condensed
                                            title="Shipping Address" />
                                    </div>
                                    <div className="col-md">
                                        {this.state.shipToAccount.contactName && <FormLabel model={this.state.shipToAccount.contactName}
                                            label="Contact Name" />}
                                        {this.state.shipToAccount.phone && <FormLabel model={this.state.shipToAccount.phone}
                                            label="Phone" />}
                                        {this.state.shipToAccount.fedexAccountNumber && <FormLabel model={this.state.shipToAccount.fedexAccountNumber}
                                            label={<><L>Carrier</L><span className="text-muted">(FedEx)</span><L>Account Number</L></>} />}
                                    </div>
                                </div>
                            </>}

                            {!this.state.item.sent &&
                                (!this.state.showAddNewShipping ? <p>
                                    <span
                                        role="button"
                                        className="text-primary"
                                        onClick={() => this.setState({
                                            shippingAccount: {
                                                address: {},
                                                billingAddress: {},
                                                shippingAddress: {}
                                            }, showAddNewShipping: true
                                        })}>
                                        Add New Shipping Account
                                    </span>
                                </p> : <>
                                    <AccountQuickEdit item={this.state.shippingAccount} />
                                    <p>
                                        <span
                                            role="button"
                                            className="text-primary"
                                            onClick={() => this.setState({ shippingAccount: null, showAddNewShipping: false })}>
                                            Cancel Adding New Shipping Account
                                        </span>
                                    </p>
                                </>)}
                        </Card>
                    </div>}
                </div>

                <div className="row">
                    {this.state.item.sent && Auth.hasRole('manager') && <div className="col-md">
                        <Card title="Approvals">
                            {this.state.item.businessApproved && this.state.item.distributionApproved
                                ? <div className="alert alert-success">Package approved for shipping. {this.state.touched && <u><L>Don't forget to save!</L></u>}</div>
                                : <div className="alert alert-warning"><L>Please review the purchase order below and trigger the approval if valid.</L></div>}
                            {Auth.hasRole('admin') && <FormInput
                                model={this.state.item}
                                name="businessApproved"
                                label="Business Approved"
                                type="switch"
                                onChange={this.change}
                                disabled={this.state.item.businessApproved && this.state.item.distributionApproved}
                            />}
                            {Auth.hasRole('manager') && <FormInput
                                model={this.state.item}
                                name="distributionApproved"
                                label="Distribution Approved"
                                type="switch"
                                onChange={this.change}
                                disabled={this.state.item.businessApproved && this.state.item.distributionApproved}
                            />}
                        </Card>
                        <Card title="File Attachments">
                            <UploadPad
                                item={this.state.item}
                                name="attachments"
                                onUploadBegin={() => this.setState({ uploading: true })}
                                onUploadEnd={() => this.setState({ uploading: false })}
                            />
                        </Card>
                    </div>}
                    <div className="col-md">
                        <Card title="FedEx Shipping Options">
                            {this.state.shippingMethods && <>
                                <FormInput model={this.state.item}
                                    name="shippingMethodID"
                                    label="Shipping Method"
                                    type="select"
                                    options={this.state.shippingMethods.filter(x => !x.isDisabled)}
                                    onChange={this.change}
                                    disabled={this.state.item.shipped || !this.state.item.shipToAccountID}
                                />
                                {this.state.item.shippingMethodID > 0 && <p>
                                    <small className="text-muted">{this.state.shippingMethods.find(i => i.id === parseInt(this.state.item.shippingMethodID))?.description}</small>
                                </p>}
                            </>}

                            {this.isCustomCarrier() && <FormInput model={this.state.item}
                                name="customCarrierName"
                                label="Courier Name"
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped}
                            />}

                            {!this.isCustomCarrier() && !this.state.shipToAccount?.fedexAccountNumber ? <FormInput model={this.state.item}
                                name="carrierAccountNumber"
                                label={<><L>Carrier</L><span className="text-muted">(FedEx)</span><L>Account Number</L></>}
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped}
                            /> : this.state.shipToAccount && <FormInput model={this.state.shipToAccount} name="fedexAccountNumber" disabled
                                label={<><L>Carrier</L><span className="text-muted">(FedEx)</span><L>Account Number</L></>} />}

                            <FormInput model={this.state.item}
                                name="receiverName"
                                label="Receiver Name"
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped || this.state.item.sent}
                            />

                            <FormInput model={this.state.item}
                                name="receiverPhone"
                                label="Receiver Phone"
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped || this.state.item.sent}
                            />
                        </Card>
                    </div>
                </div>
                {(!Auth.hasRole('billing-distributor') || this.state.item.accountID) ? <Card title="Products">
                    {!this.state.item.sent && <div className="mb-3">
                        {Auth.hasRole('consumer') ? <button type="button" className="btn btn-primary btn-lg" onClick={this.continueShopping}>
                            <FontAwesomeIcon icon={fa.faShop} /> <L>Product Menu</L></button> : <button type="button" className="btn btn-primary btn-lg" onClick={this.catalog}>
                            <FontAwesomeIcon icon={fa.faPlus} /> <L>Select from Catalog</L></button>}
                    </div>}
                    <div className="d-none d-md-block">
                        <table className="table table-fixed mt-2">
                            <thead>
                                <tr>
                                    <td>Image</td>
                                    <td>Product</td>
                                    <td>Size</td>
                                    <td>Quantity</td>
                                    {Auth.hasRole('billing-distributor')
                                        && <td><L>Price</L></td>}
                                    <td><L>Line</L></td>
                                    {Auth.hasRole('billing-distributor')
                                        && <td>Line Total <span className="text-muted">($)</span></td>}
                                    <td style={{ width: '120px' }}></td>
                                </tr>
                            </thead>

                            {this.state.item.lineItems.map((obj, idx) =>
                                <tbody key={idx}>
                                    <tr>
                                        <td style={{ width: '200px' }}>
                                            <img src={Globals.getStorageURL(obj.imageIdent)} alt="" className="img-fluid" onClick={() => this.setCurrentProduct(obj)} />
                                        </td>
                                        <td>
                                            <div className="text-muted">{obj.manufacturerName}</div>
                                            <div><strong>{obj.displayName}</strong></div>
                                        </td>
                                        <td>
                                            <div className="form-group">

                                                {(!obj.productName || this.state.item.sent) ? this.getSizeForView(obj) : <>
                                                    {obj.isPricePerUnit && <>
                                                        <label className="form-label"><L>* Size</L></label>
                                                        <select className="form-select"
                                                            onChange={(e) => this._changeSize(obj, e)}
                                                            disabled={!obj.productName || this.state.item.sent}
                                                            defaultValue={obj.productSizeID}
                                                            required>
                                                            <option><L>Select Size</L></option>
                                                            {obj.sizes.map((i, idx) => <option key={idx} value={i.id}>{i.name}</option>)}
                                                        </select>
                                                    </>}
                                                    {!obj.isPricePerUnit && <><L>Standard</L></>}
                                                </>}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="form-group">
                                                {(!obj.productName || this.state.item.sent) ? Globals.formatQuantity(obj.qty) : <>
                                                    <label className="form-label"><L>* Quantity</L></label>
                                                    <input type="number"
                                                        step={obj.incrementBy ?? 1}
                                                        className="form-control"
                                                        value={obj.qty}
                                                        onChange={(e) => this._validate(obj, e)}
                                                        disabled={!obj.productName || this.state.item.sent}
                                                        placeholder="0"
                                                        required />
                                                </>}
                                            </div>
                                        </td>
                                        {Auth.hasRole('billing-distributor')
                                            && <td>{Globals.formatCurrency(obj.sellPrice)} {obj.isPricePerUnit && <> <b><L>x</L></b><L>cm</L><sup><L><L>2</L></L></sup></>}</td>}
                                        <td>{this.getUnitCount(obj)} {obj.isPricePerUnit && <><L>cm</L><sup><L><L>2</L></L></sup></>}</td>
                                        {Auth.hasRole('billing-distributor')
                                            && <td>{Globals.formatCurrency(obj.totalPrice * obj.qty)}</td>}
                                        <td style={{ minWidth: '120px' }}>
                                            {!this.state.item.sent && <button type="button" className="btn btn-danger" onClick={() => this.remove(obj)}><FontAwesomeIcon icon={fa.faTrash} /></button>}
                                        </td>
                                    </tr>
                                    {/*<tr>
                                        <td colspan={8}>
                                            <div className="form-group">
                                                <label className="form-label"><L>Notes</L></label>
                                                {(!obj.productName || this.state.item.sent) ? <input type="text"
                                                    className="form-control"
                                                    onChange={(e) => this._changeNotes(obj, e)}
                                                    disabled={!obj.productName || this.state.item.sent} /> : obj.notes}
                                            </div>
                                        </td>
                                    </tr>*/}
                                </tbody>)}
                            <tfoot>
                                <tr>
                                    <td colSpan={4}></td>
                                    {Auth.hasRole('billing-distributor') && <td></td>}
                                    <td>{this.getAllUnitCount()}</td>
                                    <td colSpan={Auth.hasRole('billing-distributor') ? 3 : 2}>
                                        {Auth.hasRole('billing-distributor')
                                            && <strong>{Globals.formatCurrency(this.state.totalPrice ?? 0)}</strong>}
                                    </td>
                                </tr>
                            </tfoot>

                        </table>
                    </div>



                    <div className="d-block d-md-none">
                        {this.state.item.lineItems.map((obj, idx) => <Card key={idx} title={obj.manufacturerName + ' ' + obj.displayName}>
                            <div className="form-group mb-3">
                                <label className="form-label"><L>* Size</L></label>
                                {obj.isPricePerUnit && <select className="form-select"
                                    onChange={(e) => this._changeSize(obj, e)}
                                    disabled={!obj.productName || this.state.item.sent}
                                    defaultValue={obj.productSizeID}
                                    required>
                                    <option><L>Select Size</L></option>
                                    {obj.sizes.map((i, idx) => <option key={idx} value={i.id}>{i.name}</option>)}
                                </select>}
                                {!obj.isPricePerUnit && <div><i><L><L>Standard</L></L></i></div>}
                            </div>

                            <div className="form-group mb-3">
                                <label className="form-label"><L>* Quantity</L></label>
                                <input type="number"
                                    step={obj.incrementBy ?? 1}
                                    className="form-control"
                                    value={obj.qty}
                                    onChange={(e) => this._validate(obj, e)}
                                    disabled={!obj.productName || this.state.item.sent}
                                    required
                                />
                            </div>

                            {Auth.hasRole('billing-distributor') && <div className="mb-3">
                                <label className="form-label">Price{!obj.isPricePerUnit && <><L>/cm</L><sup><L><L>2</L></L></sup></>}</label>
                                <input type="text" className="form-control" value={Globals.formatCurrency(obj.sellPrice)} disabled />
                            </div>}
                            <div className="mb-3">
                                <label className="form-label">Line{!obj.isPricePerUnit && <><L>/cm</L><sup><L><L>2</L></L></sup></>}</label>
                                <input type="text" className="form-control" value={this.getUnitCount(obj)} disabled />
                            </div>
                            {Auth.hasRole('billing-distributor') && <div className="mb-3">
                                <label className="form-label"><L>Line Total</L><span className="text-muted">($)</span></label>
                                <input type="text" className="form-control" value={Globals.formatCurrency(obj.totalPrice * obj.qty)} disabled />
                            </div>}

                            <div className="form-group mb-3">
                                <label className="form-label"><L>Notes</L></label>
                                <input type="text"
                                    className="form-control"
                                    onChange={(e) => this._changeNotes(obj, e)}
                                    disabled={!obj.productName || this.state.item.sent}
                                    value={obj.notes}
                                />
                            </div>

                            {!this.state.item.sent && <button type="button" className="btn btn-danger" onClick={() => this.remove(obj)}>
                                <FontAwesomeIcon icon={fa.faTrash} /><L>Delete</L></button>}
                        </Card>)}

                        <div className="form-group mb-3">
                            <label className="form-label"><L>Total Units</L></label>
                            <div><strong>{this.getAllUnitCount()}</strong></div>
                        </div>

                        {Auth.hasRole('billing-distributor') && <div className="form-group mb-3">
                            <label className="form-label"><L>Total Price</L></label>
                            <div><strong>{Globals.formatCurrency(this.state.totalPrice ?? 0)}</strong></div>
                        </div>}

                    </div>

                </Card> : <Alert><L>Select a billing account before selecting products.</L></Alert>}

                {Auth.hasRole('admin') && this.state.item.id && <Card title="Terms and Conditions">
                    <FormInput model={this.state.item}
                        name="terms"
                        label="Terms and Conditions"
                        type="textarea"
                        disabled={this.state.item.shipped && !(this.state.modify && Auth.hasRole('admin'))}
                        onChange={this.change}
                    />
                </Card>}

                <Card title="Additional Information">
                    <FormInput model={this.state.item}
                        name="specialInstructions"
                        label="Special Instructions"
                        type="textarea"
                        placeholder="Special instructions for the order. Can be left blank if none."
                        disabled={(this.state.item.shipped && !(this.state.modify && Auth.hasRole('admin'))) || (this.state.item.sent && !Auth.hasRole('manager'))}
                        onChange={this.change}
                    />
                    {this.state.item.specialInstructions
                        && <small className="text-muted"><L>Special Instructions will be included in the Purchase Order and Packing Slip.</L></small>}
                </Card>

                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>

                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
            {this.state.currentProduct && <ProductModal currentProduct={this.state.currentProduct} onHide={() => this.setState({ currentProduct: null })} />}
        </div>;
    }
}

export default withParamsAndNavigate(PurchaseOrderView);